

/**
 * @name ShopHoursController
 * @description Controller for shop hours
 * @param {type} $rootScope Description
 * @param {service} ShopHours The shop hours service
 * @param {service} Shop The shop service
 * @param {type} ScheduleUtilFactory Description
 * @param {type} Association Description
 * @param {type} moment Description
 * @param {type} AlertMessages Description
 * @param {type} Session Description
 * @param {library} _ The Lodash library
 */
function ShopHoursController(
  $rootScope,
  ShopHours,
  Shop,
  ScheduleUtilFactory,
  Association,
  moment,
  AlertMessages,
  Session,
  _
) {
  let vm = this;
  vm.$onInit = function() {
    vm.weekdays = ScheduleUtilFactory.daysArray;
    vm.status = {};
    vm.busy = false;
    vm.shopHours = [];
  };

  // Get the shop of the logged in operator
  let shop = Session.activeState.association.shop;

  // Get shop profile
  Shop.get(shop.id).then(function(shop) {
    vm.shop = shop;
  });

  // Get the Shop Hours
  ShopHours.get(Session.activeState.association.shop.id)
  .then(function(hours) {
    vm.shopHours = hours.current;
  });

  // Send a new/updated shop schedule (to API)
  vm.update_shop_hours = function(shop_hours) {
    // Check if we're busy
    if (vm.busy === false) {
      // Indeed we NOW Are
      vm.busy = true;
      let newShopHours = _.cloneDeep(shop_hours.update);

      // New Shop Schedule
      if (shop_hours.is_new) {
        ShopHours.create(newShopHours).then(function(newHours) {
          replaceHours(shop_hours, newHours);
        });
      // Updating Existing Shop Schedule
      } else if (moment(newShopHours.startDate).startOf('day') <
      moment().startOf('day')) {
      // Past Shop Hours (Expire then Create New)
        newShopHours.startDate = moment().startOf('day').format('YYYY-MM-DD');

        // Expire
        ShopHours.expire(shop_hours).then(function(response) {
          // Create
          ShopHours.create(newShopHours).then(function(newHours) {
            replaceHours(shop_hours, newHours);
          });
        });
      // Update Only
      } else {
        ShopHours.update(newShopHours).then(function(newHours) {
          replaceHours(shop_hours, newHours);
          shop_hours.accordion_open = false;
        });
      }
    } else {
      AlertMessages.add({msg: 'Please Wait.', type: 'warning'});
    }
  };

  /**
   * @name replaceHours
   * @description description
   * @param {type} oldHours Description
   * @param {type} newHours Description
   */
  function replaceHours(oldHours, newHours) {
    ShopHours.parse([newHours]);
    vm.shopHours[vm.shopHours.indexOf(oldHours)] = newHours;
    vm.busy = false;
    AlertMessages.add({msg: 'Your shop hours have been saved.', type: 'success'});
  }

  // Cancel Adding/Updating a Shop's Hours
  vm.cancel_shop_hours_update = function(shop_hours) {
    shop_hours.accordion_open = false;
    if (shop_hours.is_new) {
      vm.status.adding = false;
      vm.shopHours.pop();
    }
  };

  // Add more Shop Hours (fill out form with blank deta).
  vm.add_shop_hours = function() {
    vm.shopHours.push({update: {startTime: moment().startOf('day'), endTime: moment().startOf('day')}, is_new: true, accordion_open: true});
    vm.status.adding = true;
  };
}

angular
.module('inkfinder')
.controller('ShopHoursController', ShopHoursController);



// WEBPACK FOOTER //
// ./components/shop/hours/shop-hours.controller.js